import { useSuspenseQuery } from '@tanstack/react-query'
import { type LoaderFunctionArgs, type RouterContextProvider, useLoaderData, useNavigate, useParams } from 'react-router'

import { clientContext } from 'apps/employer_dashboard/router_contexts'
import { pageErrorData } from 'apps/employer_dashboard/utils/errors'
import BillingBreakdown from 'components/billing/BillingBreakdown'
import { getEmployersEmployerInvoicesId, getGetEmployersEmployerInvoicesIdQueryKey } from 'utils/web_api'

export async function loader ({ context, params }: LoaderFunctionArgs<RouterContextProvider>) {
  const queryClient = context.get(clientContext)
  const { invoiceId } = params as { invoiceId: string }

  try {
    const data = await queryClient?.ensureQueryData({
      queryKey: getGetEmployersEmployerInvoicesIdQueryKey(invoiceId),
      queryFn: () => getEmployersEmployerInvoicesId(invoiceId),
    })

    return { data }
  } catch (error) {
    throw pageErrorData(error, {
      heading: 'We could not load the details for this invoice',
      message: 'Something unexpected happened. We have been notified and are looking into it.',
    })
  }
}

export function InvoiceDetailPage () {
  const { invoiceId } = useParams() as { invoiceId: string }
  const { data: initialData } = useLoaderData<typeof loader>()
  const navigate = useNavigate()

  const { data } = useSuspenseQuery({
    queryKey: getGetEmployersEmployerInvoicesIdQueryKey(invoiceId),
    queryFn: () => getEmployersEmployerInvoicesId(invoiceId),
    initialData,
  })

  return (
    <BillingBreakdown
      employerInvoice={data}
      invoiceId={invoiceId!}
      invoiceType='employer'
      onBack={() => {
        navigate('../')
      }}
    />
  )
}
